import { render, staticRenderFns } from "./CopyInput.vue?vue&type=template&id=0a68de6a&scoped=true&"
import script from "./CopyInput.vue?vue&type=script&lang=js&"
export * from "./CopyInput.vue?vue&type=script&lang=js&"
import style0 from "./CopyInput.vue?vue&type=style&index=0&id=0a68de6a&prod&lang=scss&"
import style1 from "./CopyInput.vue?vue&type=style&index=1&id=0a68de6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a68de6a",
  null
  
)

export default component.exports